import {Copyable, RawCopyable} from '@/types/types';
import {ApiConverter} from '@cquential/api';

export default class ClipboardUtils {
    public static readCopyables(): Promise<Copyable[]> {
        return window.navigator.clipboard
            .readText()
            .then((clipText: string): Copyable[] => {
                try {
                    const copyables: RawCopyable[] = JSON.parse(clipText);

                    return ClipboardUtils.convertRawCopyableToCopyables(copyables);
                } catch (error: unknown) {
                    console.error(error, clipText);

                    return [];
                }
            });
    }

    public static writeCopyables(data: Copyable[]): Promise<void> {
        return window.navigator.clipboard
            .writeText(JSON.stringify(data))
            .catch((error: DOMException): void => {
                console.error(error.message);
            });
    }

    private static convertRawCopyableToCopyables(rawCopyables: RawCopyable[]): Copyable[] {
        const copyables: Copyable[] = [];
        for (const raw of rawCopyables) {
            if (raw.type === 'deployment') {
                copyables.push({
                    ...raw,
                    object: ApiConverter.convertRawDeploymentToDeployment(raw.object),
                });
            } else {
                copyables.push({
                    ...raw,
                    object: ApiConverter.convertRawPersonalStampShiftToPersonalStampShift(raw.object),
                });
            }
        }

        return copyables;
    }
}
